import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

interface IFacilitiesWithForms {
  [key: string]: racehorse360.IStallApplicationForm[];
}

export const mapFormsToFacilitiesWithForms = (
  facilities: racehorse360.IFacility[],
  forms: racehorse360.IStallApplicationForm[]
): IFacilitiesWithForms => {
  const existingFormIds = new Set();
  const resultObject: IFacilitiesWithForms = {};

  return forms?.reduce((acc, form) => {
    form.facilityOptions.forEach(formFacility => {
      const rootFacility = facilities?.find(
        track =>
          track.id === formFacility.id ||
          track.trainingFacilities.some(
            tFacility => tFacility.id === formFacility.id
          )
      );

      if (rootFacility && !existingFormIds.has(form.id)) {
        acc[rootFacility.id] = acc[rootFacility.id]
          ? [...acc[rootFacility.id], form]
          : [form];

        existingFormIds.add(form.id);
      }
    });

    return acc;
  }, resultObject);
};
